import { ChevronDownIcon, DownloadIcon } from "@/icons";
import { Button, DatePicker } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { useState } from "react";
import AiCreditsSummary from "./_components/Summary/AiCreditsSummary";
import ApplicationTrends from "./_components/Summary/ApplicationTrends";
import RecentJobPost from "./_components/Summary/RecentJobPost";
import RecruitmentStates from "./_components/Summary/RecruitmentStates";
import UpcomingInterviews from "./_components/Summary/UpcomingInterviews";

const { RangePicker } = DatePicker;

export default function Summary() {
  const [dates, setDates] = useState<[Dayjs | null, Dayjs | null]>([
    dayjs().subtract(30, "day"),
    dayjs(),
  ]);

  return (
    <div>
      {/* Filter */}
      <div className="bg-theme-slate-800 border border-theme-gray-700 p-3 rounded-xl w-full max-w-full mx-auto">
        <div className="flex flex-wrap justify-center xl:justify-between items-center gap-3">
          <div className="relative inline-flex items-center  text-white  cursor-pointer select-none">
            {/* TEXT */}
            <span className="text-white text-xl lg:text-2xl xl:text-3xl font-bold">
              {dates[0]?.format("DD MMM, YYYY")} -{" "}
              {dates[1]?.format("DD MMM, YYYY")}
            </span>

            <ChevronDownIcon className="ml-2 text-white size-5 lg:size-6 xl:size-10" />

            {/* HIDDEN DAY RANGE PICKER */}
            <RangePicker
              value={dates}
              onChange={(val) => setDates(val as [Dayjs | null, Dayjs | null])}
              popupClassName="custom-dark-picker"
              className="absolute inset-0 opacity-0 cursor-pointer"
              allowClear={false}
              showToday={true}
              disabledDate={(current) =>
                // disable future dates
                current && current > dayjs().endOf("day")
              }
            />
          </div>

          <div className="flex gap-3 justify-end filter-section">
            {/* <Select
              size="large"
              placeholder="All Department"
              className="min-w-36 dashboard-select"
              suffixIcon={<ChevronDownIcon size={24} />}
              //   value={selectedDepartment}
              //   onChange={setSelectedDepartment}
              loading={false}
              allowClear
              popupMatchSelectWidth={200}
            /> */}

            {/* <Select
              size="large"
              className="w-36 dashboard-select"
              placeholder="All Roles"
              suffixIcon={<ChevronDownIcon size={24} />}
            /> */}

            <Button
              disabled
              size="large"
              className="btn-primary !text-neutral-700 !text-base disabled:hover:!text-neutral-700 disabled:hover:opacity-80 font-bold"
            >
              Export
              <DownloadIcon className="size-4" />
            </Button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 mt-6">
        {/* RIGHT SIDE - Show first on mobile */}
        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-4 order-1  xl:order-2">
          <RecruitmentStates />
        </div>

        {/* LEFT SIDE - Show second on mobile */}
        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-8 order-2  xl:order-1">
          <ApplicationTrends
            startDate={dates[0]?.format("YYYY-MM-DD") ?? ""}
            endDate={dates[1]?.format("YYYY-MM-DD") ?? ""}
          />
        </div>
      </div>

      {/* AI Credits Section */}
      <div className="grid grid-cols-12 gap-6 mt-6">
        <div className="col-span-12">
          <div className="text-white p-5 rounded-xl shadow-xl bg-theme-slate-800 border border-theme-gray-700">
            <AiCreditsSummary />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mt-6">
        {/* RIGHT SIDE - Show first on mobile */}
        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-4 order-1  xl:order-2">
          <UpcomingInterviews />
        </div>

        {/* LEFT SIDE - Show second on mobile */}
        <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-8 order-2  xl:order-1">
          <RecentJobPost />
        </div>
      </div>
    </div>
  );
}
